"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colors = void 0;
var colors = {
  white: '#ffffff',
  black: '#000000',
  brandThemeDark900: '#0c1e2c',
  // originally primary 1
  brandThemeDark700: '#275b86',
  // originally primary 2
  brandThemeDark500: '#3f88c5',
  // originally primary 3
  brandThemeLight500: '#d6d4c1',
  // originally secondary 1
  brandThemeLight300: '#e2ded1',
  // originally secondary 2
  brandThemeLight100: '#f1efe9',
  // originally secondary 3
  actionPrimary700: '#2e6899',
  // new
  actionPrimary500: '#3e7eb3',
  // new
  actionPrimary300: '#4ba1e9',
  // originally primary 4
  primaryFont: '#0c1e2c',
  accentFont: '#4ba1e9',
  hover: '#2d78ff',
  // error colors
  error500: '#bf0000',
  // new
  error300: '#e62323',
  // originally error
  // warning colors: orange and yellow
  warning500: '#f26800',
  // originally warning 1
  warning300: '#ff8200',
  // originally warning 2
  // darkest/worse (1) to lightest/best (3)
  success500: '#76b33b',
  // originally success 1
  success300: '#8fd848' // originally success 2

};
exports.colors = colors;